<webform-box
  class="webform-field--mobi_webform_primcalc_pdfgenerate"
  [attr.data-form-field]="id"
  [attr.data-form-container]="id"
  [content]="content"
>
  <ng-template #content>
    <span
      class="!mt-0 mobi-ui-text-block-label-major !pt-0 mobi-ui-font-tisa mobi-ui-font-size-150"
    >
      {{ title }}
    </span>
    <p>{{ value }}</p>
    <button
      class="w-full flex items-center field-spacing border-t border-b border-border hover:border-border focus:!border-border py-[7px] field-spacing"
      (click)="download()"
      target="_blank"
    >
      <span>
        {{
          'show_application' | texts: { context: 'primcalc', default: 'Antrag Anzeigen' }
        }}
      </span>
      <mobi-ui-icon-major class="ml-auto mr-0 text-interactive" name="document" />
    </button>
  </ng-template>
</webform-box>
